import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import DataCatalogTextEditor from './DataCatalogTextEditor';

const FieldDefinition = ({
    canEdit,
    description: initialDescription,
    onSave,
}: {
    canEdit: boolean;
    description?: string;
    onSave?: (value: string) => void;
}) => {
    const { t } = useTranslation();
    const [description, setDescription] = useState(initialDescription ?? '');
    const [isEditable, setIsEditable] = useState(false);

    return (
        <Box sx={{ mt: 2, mb: 4 }}>
            <Stack direction="row" sx={{ alignItems: 'center' }}>
                <Typography variant="h5" color="textPrimary">
                    {t('dataCatalog.definition')}
                </Typography>
                {canEdit && (
                    <IconButton onClick={() => setIsEditable(!isEditable)}>
                        <EditIcon color="primary" />
                    </IconButton>
                )}
            </Stack>
            <DataCatalogTextEditor
                isEditable={isEditable}
                content={description}
                canEdit={canEdit}
                onSave={(value) => {
                    setDescription(value);
                    setIsEditable(false);
                    onSave?.(value);
                }}
            />
        </Box>
    );
};

export default FieldDefinition;
